module.exports = __webpack_public_path__ + "static/img/1b.022f25a4.webp";